import {LinkInput, SanityImageType} from '@local/types'
import {Button, SanityImage, SmallText} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {forwardRef, ForwardedRef} from 'react'

export interface PodcastCardProps {
	className?: string
	image: SanityImageType
	title: string
	creator: string
	podcastLink: LinkInput
	duration: string
	isTall: boolean
}

export const PodcastCard = forwardRef(
	(
		{image, title, creator, podcastLink, duration, isTall, className}: PodcastCardProps,
		ref:ForwardedRef<HTMLElement>,
	) => {
		return (
			<article
				ref={ref}
				className={cx(
					'relative span-w-8-wide lg:span-w-2 border-b border-grey-2/50 group h-min',
					'after:absolute after:-bottom-1 after:left-0',
					'after:w-full after:h-1 after:bg-grey-2',
					'after:scale-x-0 after:hover:scale-x-100 after:focus-within:scale-100 after:origin-left',
					'after:transition-transform after:duration-500 after:ease-expo-out after:transform-gpu',
					className,
				)}>
				<Button linkInput={podcastLink} className='text-left outline-none group/btn'>
					<figure className='overflow-clip span-w-8-wide lg:span-w-2'>
						<SanityImage
							image={image}
							desktopWidth={217}
							mobileWidth={217}
							width={217}
							height={isTall ? 217 : 341}
							className={cx(
								'w-full h-full',
								'transition-transform transform-gpu duration-700 ease-[cubic-bezier(.35,0,.19,1)]',
								'scale-110 group-hover:scale-100 group-focus-visible/btn:scale-100',
							)} />
					</figure>
					<h3 className='text-12 my-12 font-[350] leading-easy tracking-snug text-grey-5'>{title}</h3>
					<SmallText className='flex justify-between pb-6 gap-10' textColor='grey-2'>
						<span>{creator}</span>
						<span>{duration}</span>
					</SmallText>
				</Button>
			</article>
		)
	},
)
